export default {
  actions: {
    async apiQuery({getters, dispatch}, {method, body, options}){
      let fetch_options = {}
      
      if (body) {
        fetch_options.headers = {}
        fetch_options.headers['content-type'] = 'application/json'
        fetch_options.method = 'POST'
        fetch_options.body = JSON.stringify(body)
      }

      if (getters.token) {
        if (!fetch_options.headers) {
          fetch_options.headers = {}
        }

        fetch_options.headers['Dlv-Auth'] = getters.token
      }

      fetch_options = Object.assign(fetch_options, options)

      try {
        var r = await fetch(`${getters.url}/api/int${method}`, fetch_options)
      } catch (e) {
        const $t = getters.localePhrase
        dispatch('throwTimeoutMessage', {
          message_data: `${$t('Ошибка связи с сервером доставки')}: ${e.message}`,
          message_class: 'error'
        })
        
        console.error($t('Ошибка API'), e)
        throw e
      }

      if (r.status != 200) {
        r = await r.json()
        
        dispatch('throwTimeoutMessage', {
          message_data: `(${r.error_class}) ${r.message}`,
          message_class: 'error'
        })

        if (r.error_class === 'AuthorizationException') {
          await dispatch('clearAuth')
        }

        console.error(`(${r.error_class}) ${r.verbose}`)
        
        let e = new Error(`(${r.error_class}) ${r.message}`)
        e.response = r

        throw e

      }

      return await r.json()
    }
  }
}